jQuery(function ($) {

  // js-slick01
  $('.js-slick01').slick({
		autoplaySpeed: 6000,
		autoplay: false,
		arrows: true,
    centerMode: true,
    dots: false,
    infinite: true,
		fade: false,
		speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
        }
      },
    ]
  });

  // js-slick02-sp
  $('.js-slick02-sp').slick({
    mobileFirst: true,
    autoplay: false,
    arrows: false,
    centerMode: true,
    dots: true,
    infinite: true,
    fade: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 769,
        settings: 'unslick'
      }
    ]
  });

  // js-slick03-sp
  $('.js-slick03-sp').slick({
    mobileFirst: true,
    autoplay: false,
    arrows: false,
    centerMode: true,
    dots: true,
    infinite: true,
    fade: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 769,
        settings: 'unslick'
      }
    ]
  });

  $(window).on('resize orientationchange', function() {
    　　$('.js-slick01.js-slick02-sp').slick('resize');
  });

});
